<template>
  <form class="card_style" @submit.prevent="addSetting()">
    <div class="container">
      <div class="row">
        <div class="d-flex align-items-center gap-2 mb-3">
          <AddFavDailog v-tooltip.left="$t('add_to_faviorites')" />
          <h3 class="my-2">
            {{ $t("Image size required to upload") }}(9 / 16)
          </h3>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeader" hidden @change="onFileChangeCropHeader" accept="image/*" @click="visibleHeader = true" />

            <Dialog v-model:visible="visibleHeader" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeader" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeader" alt="Source" />
              </div>
              <button v-if="imageSrcHeader" type="button" class="btn PrimaryButton" @click="cropImageHeader">Crop</button>
            </Dialog>
            <label
                v-if="Form.header_image"
                for="imageHeader"
                class="upload_img croppedImage"
            >
              <img :src="Form.header_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header Hotel image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderHotel" hidden @change="onFileChangeCropHeaderHotel" accept="image/*" @click="visibleHeaderHotel = true" />

            <Dialog v-model:visible="visibleHeaderHotel" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderHotel" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderHotel" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderHotel" type="button" class="btn PrimaryButton" @click="cropImageHeaderHotel">Crop</button>
            </Dialog>
            <label
                v-if="Form.header_hotel_image"
                for="imageHeaderHotel"
                class="upload_img croppedImage"
            >
              <img :src="Form.header_hotel_image" alt="Cropped" />
            </label>
          </div>

        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header Flight image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderFlight" hidden @change="onFileChangeCropHeaderFlight" accept="image/*" @click="visibleHeaderFlight = true" />

            <Dialog v-model:visible="visibleHeaderFlight" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderFlight" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderFlight" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderFlight" type="button" class="btn PrimaryButton" @click="cropImageHeaderFlight">Crop</button>
            </Dialog>
            <label
                v-if="Form.header_flight_image"
                for="imageHeaderFlight"
                class="upload_img croppedImage"
            >
              <img :src="Form.header_flight_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header Offer image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderOffer" hidden @change="onFileChangeCropHeaderOffer" accept="image/*" @click="visibleHeaderOffer = true" />

            <Dialog v-model:visible="visibleHeaderOffer" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderOffer" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderOffer" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderOffer" type="button" class="btn PrimaryButton" @click="cropImageHeaderOffer">Crop</button>
            </Dialog>
            <label
                v-if="Form.header_offer_image"
                for="imageHeaderOffer"
                class="upload_img croppedImage"
            >
              <img :src="Form.header_offer_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header Umrah image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderUmrah" hidden @change="onFileChangeCropHeaderUmrah" accept="image/*" @click="visibleHeaderUmrah = true" />

            <Dialog v-model:visible="visibleHeaderUmrah" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderUmrah" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderUmrah" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderUmrah" type="button" class="btn PrimaryButton" @click="cropImageHeaderUmrah">Crop</button>
            </Dialog>
            <label
                v-if="Form.header_umrah_image"
                for="imageHeaderUmrah"
                class="upload_img croppedImage"
            >
              <img :src="Form.header_umrah_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header offer section image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderOfferSection" hidden @change="onFileChangeCropOfferSection" accept="image/*" @click="visibleHeaderOfferSection = true" />

            <Dialog v-model:visible="visibleHeaderOfferSection" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderOfferSection" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderOfferSection" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderOfferSection" type="button" class="btn PrimaryButton" @click="cropImageOfferSection">Crop</button>
            </Dialog>
            <label
                v-if="Form.offer_section_background_image"
                for="imageHeaderOfferSection"
                class="upload_img croppedImage"
            >
              <img :src="Form.offer_section_background_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Header Subscription image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderSubscription" hidden @change="onFileChangeCropHeaderSubscription" accept="image/*" @click="visibleHeaderSubscription = true" />

            <Dialog v-model:visible="visibleHeaderSubscription" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderSubscription" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderSubscription" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderSubscription" type="button" class="btn PrimaryButton" @click="cropImageHeaderSubscription">Crop</button>
            </Dialog>
            <label
                v-if="Form.subscription_image"
                for="imageHeaderSubscription"
                class="upload_img croppedImage"
            >
              <img :src="Form.subscription_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Login image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderLogin" hidden @change="onFileChangeCropLoginImage" accept="image/*" @click="visibleHeaderLoginImage = true" />

            <Dialog v-model:visible="visibleHeaderLoginImage" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderLoginImage" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderLoginImage" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderLoginImage" type="button" class="btn PrimaryButton" @click="cropImageHeaderLoginImage">Crop</button>
            </Dialog>
            <label
                v-if="Form.login_image"
                for="imageHeaderLogin"
                class="upload_img croppedImage"
            >
              <img :src="Form.login_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Register image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderRegister" hidden @change="onFileChangeCropHeaderRegisterImage" accept="image/*" @click="visibleHeaderRegisterImage = true" />

            <Dialog v-model:visible="visibleHeaderRegisterImage" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderRegisterImage" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderRegisterImage" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderRegisterImage" type="button" class="btn PrimaryButton" @click="cropImageHeaderRegisterImage">Crop</button>
            </Dialog>
            <label
                v-if="Form.register_image"
                for="imageHeaderRegister"
                class="upload_img croppedImage"
            >
              <img :src="Form.register_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <span>Contact image</span>
          <div class="crop_image image_upload">
            <input type="file" id="imageHeaderContactImage" hidden @change="onFileChangeCropHeaderContactImage" accept="image/*" @click="visibleHeaderContactImage = true" />

            <Dialog v-model:visible="visibleHeaderContactImage" modal header="Crop Image" :closable="false" class="crop_image_dialog">
              <div v-if="imageSrcHeaderContactImage" class="imageSrc imageSrcropper px-0 mb-3">
                <img ref="image" :src="imageSrcHeaderContactImage" alt="Source" />
              </div>
              <button v-if="imageSrcHeaderContactImage" type="button" class="btn PrimaryButton" @click="cropImageHeaderContactImage">Crop</button>
            </Dialog>
            <label
                v-if="Form.contact_image"
                for="imageHeaderContactImage"
                class="upload_img croppedImage"
            >
              <img :src="Form.contact_image" alt="Cropped" />
            </label>
          </div>
        </div>
        <div class="col-12">
          <button type="submit" class="btn PrimaryButton">
            {{ $t("save") }}
          </button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import axios from "axios";
import Swal from "sweetalert2";
import AddFavDailog from "@/components/layout/addFavDailog.vue";
import Cropper from "cropperjs";
import Dialog from 'primevue/dialog';

export default {
  name: "setting-website",
  data() {
    return {
      Form: {
        header_image: null,
        header_hotel_image: null,
        header_flight_image: null,
        header_offer_image: null,
        header_umrah_image: null,
        subscription_image: null,
        offer_section_background_image: null,
        login_image: null,
        register_image: null,
        contact_image: null,
      },
      cropperHeader: null,
      visibleHeader: false,
      imageSrcHeader: null,

      cropperHeaderHotel: null,
      visibleHeaderHotel: false,
      imageSrcHeaderHotel: null,

      cropperHeaderFlight: null,
      visibleHeaderFlight: false,
      imageSrcHeaderFlight: null,

      cropperHeaderHeaderOffer: null,
      visibleHeaderHeaderOffer: false,
      imageSrcHeaderHeaderOffer: null,

      cropperHeaderUmrah: null,
      visibleHeaderUmrah: false,
      imageSrcHeaderUmrah: null,

      cropperHeaderOffer: null,
      visibleHeaderOffer: false,
      imageSrcHeaderOffer: null,

      cropperHeaderOfferSection: null,
      visibleHeaderOfferSection: false,
      imageSrcHeaderOfferSection: null,

      cropperHeaderSubscription: null,
      visibleHeaderSubscription: false,
      imageSrcHeaderSubscription: null,

      cropperHeaderLoginImage: null,
      visibleHeaderLoginImage: false,
      imageSrcHeaderLoginImage: null,

      cropperHeaderRegisterImage: null,
      visibleHeaderRegisterImage: false,
      imageSrcHeaderRegisterImage: null,

      cropperHeaderContactImage: null,
      visibleHeaderContactImage: false,
      imageSrcHeaderContactImage: null,
      
      defaultImage: require("@/assets/media/image/placeholder.jpg"),
    };
  },
  methods: {
    onFileChangeCropHeader(event) {
      this.fileDataHeaderImage = event.target.files[0];
      if (this.fileDataHeaderImage) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeader = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeader) {
              this.cropperHeader.destroy();
            }
            this.cropperHeader = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImage);
      }
    },
    cropImageHeader() {
      if (this.cropperHeader) {
        const canvas = this.cropperHeader.getCroppedCanvas();
        this.Form.header_image = canvas.toDataURL("image/webp");
        this.visibleHeader = false
      }
    },

    onFileChangeCropHeaderHotel(event) {
      this.fileDataHeaderImageHotel = event.target.files[0];
      if (this.fileDataHeaderImageHotel) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderHotel = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderHotel) {
              this.cropperHeaderHotel.destroy();
            }
            this.cropperHeaderHotel = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImageHotel);
      }
    },
    cropImageHeaderHotel() {
      if (this.cropperHeaderHotel) {
        const canvas = this.cropperHeaderHotel.getCroppedCanvas();
        this.Form.header_hotel_image = canvas.toDataURL("image/webp");
        this.visibleHeaderHotel = false
      }
    },

    onFileChangeCropHeaderFlight(event) {
      this.fileDataHeaderImageFlight = event.target.files[0];
      if (this.fileDataHeaderImageFlight) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderFlight = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderFlight) {
              this.cropperHeaderFlight.destroy();
            }
            this.cropperHeaderFlight = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImageFlight);
      }
    },
    cropImageHeaderFlight() {
      if (this.cropperHeaderFlight) {
        const canvas = this.cropperHeaderFlight.getCroppedCanvas();
        this.Form.header_flight_image = canvas.toDataURL("image/webp");
        this.visibleHeaderFlight = false
      }
    },

    onFileChangeCropHeaderOffer(event) {
      this.fileDataHeaderImageOffer = event.target.files[0];
      if (this.fileDataHeaderImageOffer) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderOffer = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderOffer) {
              this.cropperHeaderOffer.destroy();
            }
            this.cropperHeaderOffer = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImageOffer);
      }
    },
    cropImageHeaderOffer() {
      if (this.cropperHeaderOffer) {
        const canvas = this.cropperHeaderOffer.getCroppedCanvas();
        this.Form.header_offer_image = canvas.toDataURL("image/webp");
        this.visibleHeaderOffer = false
      }
    },

    onFileChangeCropHeaderUmrah(event) {
      this.fileDataHeaderImageUmrah = event.target.files[0];
      if (this.fileDataHeaderImageUmrah) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderUmrah = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderUmrah) {
              this.cropperHeaderUmrah.destroy();
            }
            this.cropperHeaderUmrah = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImageUmrah);
      }
    },
    cropImageHeaderUmrah() {
      if (this.cropperHeaderUmrah) {
        const canvas = this.cropperHeaderUmrah.getCroppedCanvas();
        this.Form.header_umrah_image = canvas.toDataURL("image/webp");
        this.visibleHeaderUmrah = false
      }
    },

    onFileChangeCropOfferSection(event) {
      this.fileDataHeaderImageOfferSection = event.target.files[0];
      if (this.fileDataHeaderImageOfferSection) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderOfferSection = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderOfferSection) {
              this.cropperHeaderOfferSection.destroy();
            }
            this.cropperHeaderOfferSection = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImageOfferSection);
      }
    },
    cropImageOfferSection() {
      if (this.cropperHeaderOfferSection) {
        const canvas = this.cropperHeaderOfferSection.getCroppedCanvas();
        this.Form.offer_section_background_image = canvas.toDataURL("image/webp");
        this.visibleHeaderOfferSection = false
      }
    },

    onFileChangeCropHeaderSubscription(event) {
      this.fileDataHeaderImageSubscription = event.target.files[0];
      if (this.fileDataHeaderImageSubscription) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderSubscription = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderSubscription) {
              this.cropperHeaderSubscription.destroy();
            }
            this.cropperHeaderSubscription = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderImageSubscription);
      }
    },
    cropImageHeaderSubscription() {
      if (this.cropperHeaderSubscription) {
        const canvas = this.cropperHeaderSubscription.getCroppedCanvas();
        this.Form.subscription_image = canvas.toDataURL("image/webp");
        this.visibleHeaderSubscription = false
      }
    },

    onFileChangeCropLoginImage(event) {
      this.fileDataHeaderLoginImage = event.target.files[0];
      if (this.fileDataHeaderLoginImage) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderLoginImage = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderLoginImage) {
              this.cropperHeaderLoginImage.destroy();
            }
            this.cropperHeaderLoginImage = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderLoginImage);
      }
    },
    cropImageHeaderLoginImage() {
      if (this.cropperHeaderLoginImage) {
        const canvas = this.cropperHeaderLoginImage.getCroppedCanvas();
        this.Form.login_image = canvas.toDataURL("image/webp");
        this.visibleHeaderLoginImage = false
      }
    },

    onFileChangeCropHeaderRegisterImage(event) {
      this.fileDataHeaderRegisterImage = event.target.files[0];
      if (this.fileDataHeaderRegisterImage) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderRegisterImage = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderRegisterImage) {
              this.cropperHeaderRegisterImage.destroy();
            }
            this.cropperHeaderRegisterImage = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderRegisterImage);
      }
    },
    cropImageHeaderRegisterImage() {
      if (this.cropperHeaderRegisterImage) {
        const canvas = this.cropperHeaderRegisterImage.getCroppedCanvas();
        this.Form.register_image = canvas.toDataURL("image/webp");
        this.visibleHeaderRegisterImage = false
      }
    },

    onFileChangeCropHeaderContactImage(event) {
      this.fileDataHeaderContactImage = event.target.files[0];
      if (this.fileDataHeaderContactImage) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.imageSrcHeaderContactImage = e.target.result;
          this.$nextTick(() => {
            if (this.cropperHeaderContactImage) {
              this.cropperHeaderContactImage.destroy();
            }
            this.cropperHeaderContactImage = new Cropper(this.$refs.image, {
              aspectRatio: 16 / 9, // Adjust as needed
              viewMode: 1,
            });
          });
        };
        reader.readAsDataURL(this.fileDataHeaderContactImage);
      }
    },
    cropImageHeaderContactImage() {
      if (this.cropperHeaderContactImage) {
        const canvas = this.cropperHeaderContactImage.getCroppedCanvas();
        this.Form.contact_image = canvas.toDataURL("image/webp");
        this.visibleHeaderContactImage = false
      }
    },

    addSetting() {
      const formData = new FormData();

      if (this.fileDataHeaderImage instanceof File) {
        formData.append("header_image", this.Form.header_image);
      }
      if (this.fileDataHeaderImageHotel instanceof File) {
        formData.append("header_hotel_image", this.Form.header_hotel_image);
      }
      if (this.fileDataHeaderImageFlight instanceof File) {
        formData.append("header_flight_image", this.Form.header_flight_image);
      }
      if (this.fileDataHeaderImageOffer instanceof File) {
        formData.append("header_offer_image", this.Form.header_offer_image);
      }
      if (this.fileDataHeaderImageUmrah instanceof File) {
        formData.append("header_umrah_image", this.Form.header_umrah_image);
      }
      if (this.fileDataHeaderImageOfferSection instanceof File) {
        formData.append(
          "offer_section_background_image",
          this.Form.offer_section_background_image
        );
      }
      if (this.fileDataHeaderImageSubscription instanceof File) {
        formData.append(
          "subscription_image",
          this.Form.subscription_image
        );
      }
      if (this.fileDataHeaderLoginImage instanceof File) {
        formData.append("login_image", this.Form.login_image);
      }
      if (this.fileDataHeaderRegisterImage instanceof File) {
        formData.append("register_image", this.Form.register_image);
      }
      if (this.fileDataHeaderContactImage instanceof File) {
        formData.append("contact_image", this.Form.contact_image);
      }

      axios
        .post("/website/web_site_headers", formData)
        .then(({ data }) => {
          Swal.fire({
            title: "",
            text: data.message,
            icon: "success",
          });
          this.Form = data.data;
        })
        .catch((error) => {
          Swal.fire({
            title: "",
            text: error.response.data.message,
            icon: "error",
          });
          this.Form = {};
        });
    },
    showSetting() {
      axios.get(`/website/web_site_headers`).then(({ data }) => {
        // console.log(data.data);
        this.Form = data.data;
      });
    },
  },
  created() {
    this.showSetting();
  },
  components: {
    AddFavDailog,
    Dialog
  },
};
</script>

<style lang="scss" scoped>
@import url("./_style.scss");
.crop_image img {
  margin-bottom: 0 !important;
  height: 100% !important;
  object-fit: cover;
}
.upload_img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.crop_image {
  position: relative;
}
.croppedImage {
  position: absolute;
  height: 100%;
  width: 100% !important;
  top: 0;
}
</style>
